<template>

    <m-edit1/>

    <m-dashboard-layout-3 v-bind='{...{"menuPosition":"blog_nav","logoText":"CRM","showSearch":true,"searchPlaceholder":"\u062c\u0633\u062a\u062c\u0648..."},...{}}' :style='""' class="" >
                <template #topbar-actions>topbar-actions   </template>
                </m-dashboard-layout-3><m-wallet-2 v-bind='{...{"title":"\u06a9\u06cc\u0641 \u067e\u0648\u0644","currencyLabel":"\u062a\u0648\u0645\u0627\u0646","chargeText":"\u0627\u0641\u0632\u0627\u06cc\u0634 \u0645\u0648\u062c\u0648\u062f\u06cc","walletText":"\u06a9\u06cc\u0641 \u067e\u0648\u0644","walletLink":null,"useStoreBalance":true,"balanceValue":0},...{}}' :style='""' class="" ></m-wallet-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout3 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout3'; import mWallet2 from '@moeinmdn/miw-alpha-components/src/package/Wallet/Wallets/Wallet2/Wallet2';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout3,mWallet2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
